import { connect } from 'react-redux';
import { compose } from 'redux';
import { withStyles } from '@material-ui/core/styles';
import StoreSelection from './StoreSelection';
import styles from './StoreSelection.styles';
import setSelectedStore from '../../modules/home/actions/generalManagerStoresActions';

const mapStateToProps = ({ user, generalManagerStores: { selectedStore } }) => {
  const brand = user?.data?.brand;
  return {
    brand,
    selectedStore: selectedStore[brand],
  };
};

const mapDispatchToProps = {
  setSelectedStore,
};

export default compose(
  withStyles(styles),
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(StoreSelection);
